import { useEffect, useState } from 'react'
import Layout from '../../layout'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { formateDate, capitalizeFirstLetter } from '../../helpers/commonFunctions';
import Breadcrums from '../../components/common/breadcrumbs'
import Loader from '../../components/common/loader'
import { GetSingleOutletHardware } from '../../services/outletManagementService'

const HARDWARE_LABELS = {
    pos: 'POS',
    kitchen: 'Kitchen',
    swipe_machine: 'Swipe Machine',
};

const HARDWARE_COLORS = {
    pos: 'bg-primary',
    kitchen: 'bg-warning text-dark',
    swipe_machine: 'bg-info',
};

const Field = ({ label, value }) => (
    <div className="col-lg-6 col-md-6 mb-3">
        <label style={{ fontSize: '0.85rem' }} className="fw-semibold d-block text-muted">{label}</label>
        <span style={{ fontSize: '0.92rem' }}>{value ?? 'N/A'}</span>
    </div>
);

const SectionTitle = ({ title }) => (
    <h6 style={{ fontSize: '0.95rem' }} className="main-content-label mb-3 mt-4 border-bottom pb-2">{title}</h6>
);

const ViewOutletHardware = () => {
    const navigate = useNavigate()
    const params = useParams()
    const location = useLocation()
    const [showDefault, setShowDefault] = useState({})
    const [loader, setLoader] = useState(true)

    const queryParams = new URLSearchParams(location.search);
    const companyId = queryParams.get('id');

    const breadcrumbs = [
        { title: "Dashboard", url: "/admin/dashboard" },
        { title: "Company", url: "/admin/company/list/1" },
        { title: "Outlet Hardwares", url: `/admin/company/outlet-hardwares/${companyId}/1` },
        { title: "View", url: "" }
    ]

    useEffect(() => {
        GetSingleOutletHardware({ id: params.id, company_id: companyId }).then(data => {
            setShowDefault(data?.data?.response || {})
            setLoader(false)
        }).catch(error => {
            console.log("error=====>", error)
            setLoader(false)
        })
    }, [])

    const d = showDefault;
    const hwType = d.hardware_used;

    return (
        <Layout>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">

                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="d-flex align-items-center gap-3">
                                <h3 className="main-content-label mb-0">View Device</h3>
                                {hwType && (
                                    <span className={`badge ${HARDWARE_COLORS[hwType] || 'bg-secondary'}`} style={{ fontSize: '0.82rem' }}>
                                        {HARDWARE_LABELS[hwType] || hwType}
                                    </span>
                                )}
                                {d.is_main_cashier && (
                                    <span className="badge bg-success" style={{ fontSize: '0.82rem' }}>Main Cashier</span>
                                )}
                                {d.status !== undefined && (
                                    <span className={`badge ${d.status ? 'bg-success' : 'bg-secondary'}`} style={{ fontSize: '0.82rem' }}>
                                        {d.status ? 'Active' : 'Inactive'}
                                    </span>
                                )}
                            </div>
                            <button className="btn btn-secondary" type="button" onClick={() => navigate(-1)}>
                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i> Back
                            </button>
                        </div>

                        {loader ? <Loader /> : Object.keys(d).length > 0 ? (
                            <div className="row">

                                {/* General Info */}
                                <div className="col-12">
                                    <SectionTitle title="General Information" />
                                    <div className="row">
                                        <Field label="Company" value={d.company?.name} />
                                        <Field label="Outlet" value={capitalizeFirstLetter(d.outlet?.outlet_name)} />
                                        <Field label="Brand" value={capitalizeFirstLetter(d.outlet?.brand?.name)} />
                                        <Field label="Hardware Type" value={HARDWARE_LABELS[hwType] || hwType} />
                                        <Field label="Assigned Date" value={d.created_at ? formateDate(d.created_at) : null} />
                                    </div>
                                </div>

                                {/* POS Details */}
                                {hwType === 'pos' && (
                                    <div className="col-12">
                                        <SectionTitle title="POS Device Details" />
                                        <div className="row">
                                            <Field label="Device Name" value={d.name} />
                                            <Field label="Registration ID" value={d.registration_id} />
                                            <Field label="Customer Printer Name" value={d.customer_printer_name} />
                                            <Field label="Customer Printer IP" value={d.customer_printer_ip} />
                                            <Field label="Kitchen Printer Name" value={d.kitchen_printer_name} />
                                            <Field label="Kitchen Printer IP" value={d.kitchen_printer_ip} />
                                        </div>
                                    </div>
                                )}

                                {/* Kitchen Details */}
                                {hwType === 'kitchen' && (
                                    <div className="col-12">
                                        <SectionTitle title="Kitchen Device Details" />
                                        <div className="row">
                                            <Field label="Device Name" value={d.kitchen_device_name} />
                                            <Field label="Registration ID" value={d.kitchen_device_registration_id} />
                                        </div>
                                    </div>
                                )}

                                {/* Swipe Machine Details */}
                                {hwType === 'swipe_machine' && (
                                    <div className="col-12">
                                        <SectionTitle title="Swipe Machine Details" />
                                        <div className="row">
                                            <Field label="Swipe Machine Type" value={capitalizeFirstLetter(d.swipe_machine)} />
                                        </div>
                                    </div>
                                )}

                            </div>
                        ) : (
                            <p className="text-center text-muted">No data found.</p>
                        )}

                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default ViewOutletHardware
